import { useEffect } from 'react';
import useFocus from './useFocus';
const useFocusOnMount = () => {
    const [ref, setFocus] = useFocus();
    useEffect(() => setFocus(), [setFocus]);
    return ref;
};
export default useFocusOnMount;
//# sourceMappingURL=useFocusOnMount.js.map